import { useState } from "react";
import { Loader2 } from "lucide-react";
import ProfileHeader from "./employee/ProfileHeader";
import ProfileTabs from "./employee/ProfileTabs";
import ProfileSidebar from "./employee/ProfileSidebar";
import PersonalTab from "./employee/sections/PersonalTab";
import ProjectsTab from "./employee/sections/ProjectsTab";
import ProfessionalTab from "./employee/sections/ProfessionalTab";
import SkillsTab from "./employee/sections/SkillsTab";
import EducationTab from "./employee/sections/EducationTab";
import CertificationsTab from "./employee/sections/CertificationsTab";
import AwardsTab from "./employee/sections/AwardsTab";
import ProfileEditModal from "./employee/ProfileEditModal";
import { useCurrentUser } from "../auth/hooks/useAuth";

export default function EmployeeProfile() {
  const [activeTab, setActiveTab] = useState("Personal");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const { data: currentUser, isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center p-24">
        <Loader2 className="w-10 h-10 animate-spin text-purple-600" />
      </div>
    );
  }

  return (
    <div className="w-full max-w-[1920px] mx-auto space-y-6">
      {/* 1. Header Banner */}
      <ProfileHeader
        profileData={currentUser}
        onEditClick={() => setIsEditModalOpen(true)}
      />

      {/* 2. Main Layout (Left Content + Right Sidebar) */}
      <div className="grid grid-cols-1 xl:grid-cols-4 gap-6">
        {/* Left Content Area (Tabs + Sections) */}
        <div className="xl:col-span-3 min-w-0 space-y-6">
          <ProfileTabs activeTab={activeTab} setActiveTab={setActiveTab} />

          <div className="min-h-[500px]">
            {activeTab === "Personal" && <PersonalTab />}
            {activeTab === "Experience" && <ProfessionalTab />}
            {activeTab === "Skills" && <SkillsTab />}
            {activeTab === "Projects" && <ProjectsTab />}
            {activeTab === "Education" && <EducationTab />}
            {activeTab === "Certifications" && <CertificationsTab />}
            {activeTab === "Awards" && <AwardsTab />}
            {/* Fallback for unbuilt tabs */}
            {["Overview", "More"].includes(activeTab) && (
              <div className="bg-white dark:bg-slate-900 rounded-2xl p-12 text-center border border-slate-200 dark:border-slate-800">
                <p className="text-slate-500 dark:text-slate-400">
                  The {activeTab} section is currently under construction.
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Right Sidebar Area */}
        <div className="xl:col-span-1">
          <ProfileSidebar profileData={currentUser} />
        </div>
      </div>

      <ProfileEditModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        profileData={currentUser}
      />
    </div>
  );
}
